//#region IMPORT
import React, { useEffect } from 'react';
import { BusinessCommon } from '../../../../Components/BusinessCommon';
import { Button } from '../../../../Components/MUIs';
import { getColumnDefs1 } from './POL_BASIC_01_ColumnDefs';

//#endregion

function POL_BASICF_01(props) {
  // 사전준비 그리드 컬럼
  const columnDefs1 = getColumnDefs1(props);

  //#region AuthButton 이벤트
  useEffect(() => {
    if (props.filterClick1) {
      props.gridRef1.current.api &&
        props.gridRef1.current.api.setQuickFilter(
          props.searchRef.current.searchText
        );
      props.setFilterClick1(false);
    }
    if (props.saveClick1) {
      props.SaveLogic1();
      props.setSaveClick1(false);
    }
    if (props.printClick1) {
      props.PrintLogic1();
      props.setPrintClick1(false);
    }
    if (props.listClick1) {
      props.setModalToggle3(true);
      props.SearchLogic4();
      props.setListClick1(false);
    }
    if (props.copyClick1) {
      props.RiskComplete();
      props.setCopyClick1(false);
    }
  }, [
    props.filterClick1,
    props.printClick1,
    props.listClick1,
    props.copyClick1,
    props.saveClick1,
  ]);

  //#endregion
  return (
    <React.Fragment>
      <BusinessCommon
        gridId={props.gridId1}
        getRowId={(params) => {
          return params.data.no;
        }}
        addClick1={() => {
          if (!props.validateSelection()) return;

          props.HandleAddClick(props.gridRef1);
        }}
        deleteClick1={(e) => {
          if (!props.validateSelection()) return;

          const newRowExists = props.selectedRowData1.some(
            (row) => row.newYn === 'Y'
          );

          if (!newRowExists) {
            props.MarkedForDeletion1(props.selectedRowData1);
          } else {
            props.NewYnErrorMsg();
            props.inputRef.current?.focus();
          }
        }}
        refreshClick1={() => {
          props.SearchLogic1();
        }}
        title1={'안전보건경영방침 기본정보'}
        title2={'안전보건경영방침 상세정보'}
        leftSize={55}
        rightSize={45}
        gridRef={props.gridRef1}
        columnDefs={columnDefs1}
        rowData={props.rowData1}
        rowSelection="multiple"
        rowMultiSelectWithClick={true}
        setSelectedRowData={props.setSelectedRowData1}
        setChangedRowData={props.setChangedRowData1}
        tableData={props.viewMode === 'table' && props.tableData}
        colWidth={props.colWidth}
        suppressRowClickSelection={true}
        onCellClicked={(e) => {
          const gridApi = props.gridRef1.current.api;
          const clickedRowIndex = e.rowIndex;

          const isCheckboxClick = e.event?.target?.type === 'checkbox';

          if (!isCheckboxClick) {
            gridApi.ensureIndexVisible(clickedRowIndex, 'middle');
            gridApi.setFocusedCell(clickedRowIndex, 'date');

            const copied = JSON.parse(JSON.stringify(e.data));
            props.handleRowSelection(copied, clickedRowIndex);

            gridApi
              .getDisplayedRowAtIndex(clickedRowIndex)
              ?.setSelected(true, false);
          }
        }}
        onSelectionChanged={() => {
          const gridApi = props.gridRef1?.current?.api;
          const selectedNodes = gridApi.getSelectedNodes();
          const selectedData = selectedNodes.map((n) => n.data);
          props.selectedRowNosRef1.current = new Set(
            selectedData.map((r) => r.no)
          );
          props.setSelectedRowData1(selectedData);
        }}
        viewMode={props.viewMode}
        selectedRowData={props.selectedRowData1}
        fileNameField="saveName"
        filePathField="filePath"
        other1={
          <>
            {/* 멀티 다운로드 훅으로 빼야함 */}
            <Button
              name="멀티 다운로드"
              onClick={() => {
                if (!props.validateSelection()) return;

                if (props.selectedRowData1?.length === 0) {
                  props.dispatch(
                    props.showSnackbar({
                      message: '다운로드할 항목을 먼저 선택해 주세요.',
                      type: 'warning',
                    })
                  );

                  return;
                }

                props.selectedRowData1.forEach((item, index) => {
                  setTimeout(() => {
                    props.DownloadLogic2(item);

                    // 마지막 항목일 때만 메시지 출력
                    // if (index === props.selectedRowData1.length - 1) {
                    //   setTimeout(() => {
                    //     props.dispatch(props.showSnackbar({ message: '모든 파일 다운로드 완료', type: 'success' }));
                    //   }, 500);
                    // }
                  }, index * 300);
                });
              }}
            />
          </>
        }
      />
    </React.Fragment>
  );
}

export default POL_BASICF_01;
